import PropTypes from "prop-types"
import { isFunction } from "lodash"
export default function ExternalLinks({ children, onLinkClick }) {
  const handleClick = (event) => {
    const link = event.target.closest("a")
    if (!link) {
      return null
    }

    event.preventDefault()

    if (isFunction(onLinkClick)) {
      onLinkClick(link.href, link.textContent)
    }

    window.open(link.href, "_blank")
  }

  return (
    <div onClick={handleClick}>
      {children}
    </div>
  )
}

ExternalLinks.propTypes = {
  children: PropTypes.node.isRequired,
  onLinkClick: PropTypes.func,
}
